/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { HttpErrorResponse } from '@angular/common/http';

export class RestError {
  private _status: number; // error code
  get status(): number {
    return this._status;
  }
  set status(value: number | string) {
    if (typeof value === 'string') {
      this._status = parseInt(value, 10);
      return;
    }
    this._status = value;
  }
  public statusText: string; // error text
  public title: string;
  public message: string;
  public source: string;

  private _httpError: HttpErrorResponse;
  set httpError(value: HttpErrorResponse) {
    this._httpError = value;
    this.status = value.status;
    this.statusText = value.statusText;
    // Check the body
    if (value.error && Object.hasOwn(value.error, 'code')) {
      this.status = value.error.code;
    }
    if (value.error && Object.hasOwn(value.error, 'message')) {
      this.statusText = value.error.message;
    }
  }
  get httpError(): HttpErrorResponse {
    return this._httpError;
  }

  constructor(error: HttpErrorResponse) {
    this.httpError = error;
    this.generateErrorDisplay();
  }

  public toString() {
    if (this.status !== 409) {
      return `(${this.status}) ${this.statusText}`;
    }
    return null;
  }

  private generateErrorDisplay() {
    switch (true) {
      case this.status >= 500 && this.status < 600:
        this.title = 'restError.serverError.title';
        this.message = 'restError.serverError.content';
        break;
      case this.status === 401:
        this.title = 'restError.token.title';
        this.message = 'restError.token.content';
        break;
      case this.status === 403:
        this.title = 'restError.noAccess.title';
        this.message = 'restError.noAccess.content';
        break;
      case this.status === 409:
        this.title = 'restError.badRequest.title';
        this.message = this.statusText;
        break;
      case this.status === 413:
        this.title = 'restError.resultTooLarge.title';
        this.message = 'restError.resultTooLarge.content';
        break;
      case this.status >= 400 && this.status < 500:
        this.title = 'restError.notAvailable.title';
        this.message = 'restError.notAvailable.content';
        break;
      default:
        this.title = 'restError.serverError.title';
        this.message = 'restError.serverError.content';
    }
  }
}
